// extracted by mini-css-extract-plugin
module.exports = {"article":"article--jBLTp","main":"main--3-X_L","button":"button--dzeLb","icon":"icon--xehsW"};